export const ENROLL_MEMBER_IN_FACILITTY = 'ENROLL_MEMBER_IN_FACILITTY';
